var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-player-core"},[_c('video',{directives:[{name:"videoLogger",rawName:"v-videoLogger"}],staticClass:"player",attrs:{"preload":"metadata","webkit-playsinline":"","playsinline":"","controls":"","poster":this.poster}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f1c5648","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/VideoPlayer/VideoPlayerCore.vue
// module id = null
// module chunks = 